export default __webpack_public_path__ + "static/blob3-bdfe0f1f50d4ae5cb52ca156cd795edc.svg";